module.exports = __webpack_public_path__ + "static/img/half_pitch_white.29bea66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/half_pitch_white.png
// module id = 8+0S
// module chunks = 79